import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField
} from "@mui/material";
import { ApiResponse } from "../../../models/ApiResponse";
import api from "../../../services/ApiService";
import { DataFieldWithTypes } from "../../../models/DataFieldDetail";
import { MutableRefObject, useEffect } from "react";
import DataTypeSetting from "../DataTypeSetting";
import Loader from "../../../components/Loader";
import { FormikProps } from "formik";
import { DataTypeDetail } from "../../../models/DataTypeDetail";
import { GridRowModesModel } from "@mui/x-data-grid";
import { CellError } from ".";
import { GridApiCommunity } from "@mui/x-data-grid/internals";

interface DataFieldTypeModalProps {
    isOpen: boolean;
    onClose: VoidFunction;
    formik: FormikProps<DataFieldWithTypes>;
    typesValues: DataTypeDetail[];
    setTypesValues: (types: DataTypeDetail[]) => void;
    dataField: DataFieldWithTypes;
    setDataField: (dataField: DataFieldWithTypes) => void;
    apiRef: MutableRefObject<GridApiCommunity>;
    editingRows: DataTypeDetail[];
    setEditingRows: (editingRows: DataTypeDetail[]) => void;
    handleSubmit: (updatedDataTypes?: DataTypeDetail[]) => void;
    submitValues: DataFieldWithTypes;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
    cellErrors: CellError;
    setCellErrors: (cellErrors: CellError) => void;
    rowModesModel: GridRowModesModel;
    setRowModesModel: (rowModesModel: GridRowModesModel) => void;
};

const DataFieldTypeModal = (props: DataFieldTypeModalProps & { isButtonDisabled: boolean; }) => {
    const {
        typesValues,
        setTypesValues,
        dataField,
        setDataField,
        apiRef,
        editingRows,
        setEditingRows,
        handleSubmit,
        submitValues,
        isLoading,
        setIsLoading,
        cellErrors,
        setCellErrors,
        rowModesModel,
        setRowModesModel
    } = props;

    useEffect(() => {
        if(formik.values.id > 0) {
            getDataTypeList();
            setTypesValues(formik.values.types);
        }
    }, []);

    const getDataTypeList = async () => {
        const getDataTypeResponse = await api.get<
        ApiResponse<DataFieldWithTypes>
        >(`/Picklist/cvl/${formik.values.id}`);
        if (getDataTypeResponse.isSuccess) {
            formik.resetForm();
            formik.setValues(getDataTypeResponse.data);
            setTypesValues(getDataTypeResponse.data.types);
            setDataField(getDataTypeResponse.data);
        }
        setIsLoading(false);
    };

    const { isOpen, onClose, formik, isButtonDisabled } = props;
    return (
        <Dialog className="data-field-type" open={isOpen} onClose={onClose} fullWidth maxWidth="xl">
            <Loader isLoading={isLoading} />
            <DialogActions className="close-action">
                <Button onClick={onClose}>x</Button>
            </DialogActions>
           <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                    <Box className="dialog-header">
                        <h1>Manage CVL Values</h1>
                    </Box>
                    <Box className="flex cvl-and-active-combo">
                        <Box className="data-field-container">
                            <h4 className="label">CVL Name</h4>
                            {formik.values?.id ? <p className="label readonly-data-field">{formik.values.field}</p>
                                : <TextField
                                    autoFocus
                                    id="field"
                                    name="field"
                                    type="text"
                                    disabled={!!formik.values?.id}
                                    value={formik.values?.field}
                                    onChange={formik.handleChange}
                                    error={!!formik.touched?.field && !!formik.errors?.field}
                                    onBlur={formik.handleBlur}
                                    helperText={formik.touched?.field && formik.errors?.field ? formik.errors?.field : ""}
                                />}
                        </Box>
                        {!(formik.values?.id && formik.values?.field === "CubeMultiplier") && <Box className="active-field">
                            <h4 className="label">Set Active</h4>
                            <RadioGroup
                                row
                                name="isActive"
                                value={formik.values.isActive}
                                onChange={(event) => formik.handleChange(event)}
                            >
                                <FormControlLabel value={true} control={<Radio />} label="Active" />
                                <FormControlLabel value={false} control={<Radio />} label="Inactive" />
                            </RadioGroup>
                        </Box>}
                    </Box>
                    <Box>
                        <DataTypeSetting 
                            cellErrors={cellErrors} 
                            setCellErrors={setCellErrors} 
                            submitValues={submitValues} 
                            handleSubmit={handleSubmit} 
                            editingRows={editingRows} 
                            setEditingRows={setEditingRows} 
                            apiRef={apiRef} 
                            dataField={dataField} 
                            dataTypeRows={typesValues || []} 
                            setDataTypeRows={setTypesValues}
                            rowModesModel={rowModesModel}
                            setRowModesModel={setRowModesModel}
                            getDataTypeList={getDataTypeList}
                        />
                    </Box>
                    <DialogActions>
                        <Button variant="contained" type="submit" disabled={isButtonDisabled}>
                            Save Changes
                        </Button>
                    </DialogActions>
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default DataFieldTypeModal;